import bokalSourage from 'services/bokalSourage';

const consoleStyle = 'background: #666; color: #bada55; padding: 2px 4px; border-radius: 2px';
console.log(`%csd-app ${ process.env.VERSION } (${ process.env.BRANCH })`, consoleStyle);

export const DEV = process.env.NODE_ENV === 'development' || bokalSourage.get('DEV');
export const PROD = window.location.hostname === 'my.smalldata.app' || bokalSourage.get('PROD');

const { userAgent } = window.navigator;
export const BROWSER = userAgent.includes('Chrome') ? 'Chrome'
  : userAgent.includes('Safari') ? 'Safari'
  : userAgent.includes('Firefox') ? 'Firefox'
  : userAgent.includes('Trident') || userAgent.includes('MSI') ? 'IE'
  : null;

export const OS = userAgent.includes('Mac') ? 'Mac'
  : userAgent.includes('Win') ? 'Win'
  : userAgent.includes('iP') ? 'iOS'
  : null;

console.log(`%cOS: ${ OS }; Browser: ${ BROWSER }`, consoleStyle);

export const dateFormatOpts = { delimiter: '-', reverse: true, year: 'full' };

export const AUTH_RETURN_URLS = 'AUTH_RETURN_URLS';
